import styled from 'styled-components';
import GoalProgressCircle from 'challenge/common/GoalProgressCircle';
import Btn021 from 'dc/Btn021';

export const ProgressCircle = styled(GoalProgressCircle)`
  margin-top: 16px;
`;

export const Button = styled(Btn021)`
  margin-top: 14px;
  margin-bottom: 6px;
  width: 100%;
`;
